/**
 * Data API を利用してコンテンツデータ、記事を複製します。一覧画面での複製にも対応しています。
 *
 * Updated: 2020/02/18
 *
 * @requires jQuery, mtappVars
 * @param {Object} options
 * @param {String} options.additionalText 複製元のタイトルにつけるテキストを設定します（初期値：'のコピー'）。
 * @param {String} options.basenameFieldId アーカイブマッピングで出力されるファイル名に利用しているフィールドを指定します。（初期値：'basename'）。
 * @param {String} options.basenameAdditionalText basenameFieldId オプションで指定したフィールドの値に付け足すテキストを設定します（初期値：'-copy'）。
 * @param {Number} options.contentDataTitleFieldId コンテンツデータの場合はタイトルとなるフィールドの ID をセットします。データ識別子をそのまま利用している場合は設定不要です。
 * @param {String} options.contentDataTitleFieldLabel コンテンツデータの場合はタイトルとなるフィールドのラベルをセットします。
 * @param {Function} options.cbModifyContent 複製元のコンテンツを複製する前に編集する関数を設定します。この関数の引数には複製するコンテンツのオブジェクトが渡されます。編集後のオブジェクトを return します。
 */
import { loadingImage } from './loadingImage.js';
import { toJSONString } from './toJSONString.js';
import { modalMsg } from './modalMsg.js';
import { modalConfirm } from './modalConfirm.js';

export function duplicateContent(options) {
    const op = {
        additionalText: 'のコピー',
        basenameFieldId: 'basename',
        basenameAdditionalText: '-copy',
        contentDataTitleFieldId: 0,
        contentDataTitleFieldLabel: 'タイトル',
        cbModifyContent: null,
        ...options
    };

    // すでに duplicateContent が適用されている場合は何もしない
    window.mtappVars.__system = window.mtappVars.__system || {};
    if (typeof window.mtappVars.__system.hasDuplicateFunction === 'undefined') {
        window.mtappVars.__system.hasDuplicateFunction = true;
    } else {
        return;
    }

    // 複製ボタンを作成、挿入、取得
    const duplicateButton = '<button type="button" id="mtapp-duplicate-button" class="btn btn-warning text-white">複製</button>';
    // コンテンツデータ編集の場合
    if (['edit-content-type-data', 'edit-entry'].indexOf(mtappVars.screen_id) !== -1) {
        jQuery('#entry-publishing-widget').find('.btn-primary:last').parent().append(duplicateButton);
    } else if (['list-content_data', 'list-entry'].indexOf(mtappVars.screen_id) !== -1) {
        const deleteButton = jQuery('#actions-bar-top [data-action-id="delete"]').first();
        if (deleteButton.length) {
            deleteButton.after(duplicateButton);
        } else {
            jQuery(window).on('listReady.mtapp.duplicate', function () {
                jQuery('#actions-bar-top [data-action-id="delete"]').after(duplicateButton);
                jQuery(window).off('listReady.mtapp.duplicate');
            });
        }
    }

    // DOM を取得
    const $body = jQuery('body');
    const modalElement = document.getElementById('mtapp-modal-duplicate');
    const modal = new bootstrap.Modal(modalElement);
    const $duplicateModalTitleLabel = jQuery('#mtapp-modal-duplicate-title-label');
    const $duplicateModalNewTitle = jQuery('#mtapp-modal-duplicate-new-title');
    const $duplicateModalSubmit = jQuery('#mtapp-modal-duplicate-submit');

    // 複製を実行
    $body.on('mtapp.duplicate', function (event, collection, confirm) {
        if (!Array.isArray(collection) || collection.length === 0) {
            return alert('Invalid arguments');
        }

        const doDuplicate = function () {
            let updatedCount = 0;

            loadingImage('show');

            // コンテンツデータの場合
            if (['edit-content-type-data', 'list-content_data'].indexOf(mtappVars.screen_id) !== -1) {
                collection.forEach(function (cd) {
                    if (op.basenameFieldId === 'basename') {
                        cd.basename += op.basenameAdditionalText;
                    } else if (Number(op.basenameFieldId) > 0) {
                        for (const field of cd.data) {
                            if (Number(field.id) === Number(op.basenameFieldId)) {
                                field.data += op.basenameAdditionalText;
                                break;
                            }
                        }
                    }
                    const newCd = toJSONString(cd);
                    mtappVars.DataAPI.createContentData(mtappVars.blog_id, mtappVars.content_type_id, newCd, function (response) {
                        // エラーの場合
                        if (response.error) {
                            loadingImage('hide');
                            modalMsg({
                                type: 'error',
                                title: 'エラー',
                                content: response.error.message
                            });
                            return;
                        }

                        // 成功した場合
                        if (response.id) {
                            updatedCount++;
                            // すべて終了した場合
                            if (updatedCount === collection.length) {
                                if (updatedCount === 1) {
                                    location.href =
                                        mtappVars.adminScript +
                                        '?__mode=view&content_type_id=' +
                                        mtappVars.content_type_id +
                                        '&_type=content_data&id=' +
                                        response.id +
                                        '&type=content_data_' +
                                        mtappVars.content_type_id +
                                        '&blog_id=' +
                                        mtappVars.blog_id;
                                } else {
                                    location.href =
                                        mtappVars.adminScript +
                                        '?__mode=list&_type=content_data&type=content_data_' +
                                        mtappVars.content_type_id +
                                        '&blog_id=' +
                                        mtappVars.blog_id;
                                }
                            }
                        }
                    });
                });
            }
            // 記事の場合
            else if (['edit-entry', 'list-entry'].indexOf(mtappVars.screen_id) !== -1) {
                collection.forEach(function (entry) {
                    if (op.basenameFieldId.includes('field.')) {
                        for (const customField of entry.customFields) {
                            if (customField.basename === op.basenameFieldId.replace(/field./, '')) {
                                if (customField.value) {
                                    customField.value += op.basenameAdditionalText;
                                } else {
                                    customField.value = op.basenameAdditionalText;
                                }
                                break;
                            }
                        }
                    } else if (Object.prototype.hasOwnProperty.call(entry, op.basenameFieldId)) {
                        entry[op.basenameFieldId] += op.basenameAdditionalText;
                    }
                    const newEntry = toJSONString(entry);
                    mtappVars.DataAPI.createEntry(mtappVars.blog_id, newEntry, function (response) {
                        // エラーの場合
                        if (response.error) {
                            loadingImage('hide');
                            modalMsg({
                                type: 'error',
                                title: 'エラー',
                                content: response.error.message
                            });
                            return;
                        }

                        // 成功した場合
                        if (response.id) {
                            updatedCount++;
                            // すべて終了した場合
                            if (updatedCount === collection.length) {
                                if (updatedCount === 1) {
                                    location.href =
                                        mtappVars.adminScript +
                                        '?__mode=view&_type=entry&blog_id=' +
                                        mtappVars.blog_id +
                                        '&id=' +
                                        response.id;
                                } else {
                                    location.href = mtappVars.adminScript + '?__mode=list&_type=entry&blog_id=' + mtappVars.blog_id;
                                }
                            }
                        }
                    });
                });
            }
        };

        if (confirm) {
            modalConfirm({
                type: 'warning',
                title: '確認',
                content: '複製しますか？',
                okButtonLabel: 'OK',
                cancelButtonLabel: 'キャンセル',
                callback: function () {
                    doDuplicate();
                }
            });
        } else {
            doDuplicate();
        }
    });
    // END 複製を実行

    // ウィジェットやアクションバーの複製ボタンをクリックしたときの処理
    $body.on('click.duplicateContent', '#mtapp-duplicate-button', function () {
        let ids = [];

        if ($duplicateModalTitleLabel.length) {
            $duplicateModalTitleLabel.html(op.contentDataTitleFieldLabel);
        }

        // 編集画面で実行された場合
        if (['edit-content-type-data', 'edit-entry'].indexOf(mtappVars.screen_id) !== -1) {
            if (!mtappVars.id) {
                modalMsg({
                    type: 'error',
                    title: 'エラー',
                    content: '複製するコンテンツが保存されていません。'
                });
                return;
            }
            ids.push(mtappVars.id);
        }
        // 一覧画面で実行された場合
        else if (['list-content_data', 'list-entry'].indexOf(mtappVars.screen_id) !== -1) {
            jQuery('[data-is="list-table"] [name="id"]:checked').each(function () {
                ids.push(jQuery(this).val());
            });
            if (ids.length === 0) {
                modalMsg({
                    type: 'error',
                    title: 'エラー',
                    content: '複製するコンテンツが選択されていません。'
                });
                return;
            }
        }

        // コンテンツデータの場合
        if (['edit-content-type-data', 'list-content_data'].indexOf(mtappVars.screen_id) !== -1) {
            loadingImage('show');

            // コンテンツデータを取得
            mtappVars.DataAPI.listContentData(
                mtappVars.blog_id,
                mtappVars.content_type_id,
                { limit: 1000, includeIds: ids.join(',') },
                function (response) {
                    loadingImage('hide');

                    // エラーの場合
                    if (response.error) {
                        modalMsg({
                            type: 'error',
                            title: 'エラー',
                            content: response.error.message
                        });
                        return;
                    }

                    // items が空の場合
                    if (response.items.length === 0) {
                        modalMsg({
                            type: 'error',
                            title: 'エラー',
                            content: '複製元のデータが見つかりません。'
                        });
                        return;
                    }

                    loadingImage('hide');

                    // 取得したすべてのコンテンツデータを調整
                    let currentTitle = '';
                    let updateContentData = response.items.map(function (cd) {
                        // 共通の処理
                        delete cd.id;
                        cd.status = 'Draft';
                        // 日時をリセット
                        delete cd.date;
                        delete cd.createdDate;
                        delete cd.modifiedDate;
                        // タイトルを調整
                        if (op.contentDataTitleFieldId) {
                            op.contentDataTitleFieldId = Number(op.contentDataTitleFieldId);
                            for (let i = 0; i < cd.data.length; i++) {
                                if (Number(cd.data[i].id) === op.contentDataTitleFieldId) {
                                    currentTitle = cd.data[i].data + op.additionalText;
                                    cd.data[i].data = currentTitle;
                                }
                            }
                        } else {
                            currentTitle = cd.label + op.additionalText;
                        }
                        cd.label = currentTitle;

                        // コールバックでの処理
                        if (typeof op.cbModifyContent === 'function') {
                            cd = op.cbModifyContent(cd);
                        }

                        return cd;
                    });

                    // コンテンツデータ編集画面で実行された場合
                    if (mtappVars.screen_id === 'edit-content-type-data') {
                        // モーダルに複製後のタイトルのセット
                        $duplicateModalNewTitle.val(currentTitle);

                        // 複製モーダルを表示
                        modal.show();

                        // モーダルの複製ボタンがクリックされたときの処理
                        $duplicateModalSubmit.off('click.mtapp.duplicate').on('click.mtapp.duplicate', function () {
                            // 編集したタイトルをセット
                            if (op.contentDataTitleFieldId) {
                                op.contentDataTitleFieldId = Number(op.contentDataTitleFieldId);
                                for (let i = 0; i < updateContentData[0].data.length; i++) {
                                    if (Number(updateContentData[0].data[i].id) === op.contentDataTitleFieldId) {
                                        updateContentData[0].data[i].data = $duplicateModalNewTitle.val();
                                    }
                                }
                            }
                            updateContentData[0].label = $duplicateModalNewTitle.val();

                            modal.hide();
                            $body.trigger('mtapp.duplicate', [updateContentData, false]);
                        });
                    }
                    // コンテンツデータ一覧画面で実行された場合
                    else if (mtappVars.screen_id === 'list-content_data') {
                        $body.trigger('mtapp.duplicate', [updateContentData, true]);
                    }
                }
            );
        }
        // 記事の場合
        else if (['edit-entry', 'list-entry'].indexOf(mtappVars.screen_id) !== -1) {
            loadingImage('show');

            // 記事を取得
            mtappVars.DataAPI.listEntries(
                mtappVars.blog_id,
                mtappVars.content_type_id,
                { limit: 1000, includeIds: ids.join(',') },
                function (response) {
                    loadingImage('hide');

                    // エラーの場合
                    if (response.error) {
                        modalMsg({
                            type: 'error',
                            title: 'エラー',
                            content: response.error.message
                        });
                        return;
                    }

                    // items が空の場合
                    if (response.items.length === 0) {
                        modalMsg({
                            type: 'error',
                            title: 'エラー',
                            content: '複製元のデータが見つかりません。'
                        });
                        return;
                    }

                    // 取得したすべての記事を調整
                    let currentTitle = '';

                    let updateContentData = response.items.map(function (entry) {
                        // 共通の処理
                        delete entry.id;
                        entry.status = 'Draft';
                        // タイトルを調整
                        currentTitle = entry.title + op.additionalText;
                        entry.title = currentTitle;
                        // 日時をリセット
                        delete entry.date;
                        delete entry.createdDate;
                        delete entry.modifiedDate;
                        // コールバックでの処理
                        if (typeof op.cbModifyContent === 'function') {
                            entry = op.cbModifyContent(entry);
                        }

                        return entry;
                    });

                    // 記事編集画面で実行された場合
                    if (mtappVars.screen_id === 'edit-entry') {
                        // モーダルに複製後のタイトルのセット
                        $duplicateModalNewTitle.val(currentTitle);

                        // 複製モーダルを表示
                        modal.show();

                        // モーダルの複製ボタンがクリックされたときの処理
                        $duplicateModalSubmit.off('click.mtapp.duplicate').on('click.mtapp.duplicate', function () {
                            // 編集したタイトルをセット
                            updateContentData[0].title = $duplicateModalNewTitle.val();

                            modal.hide();
                            $body.trigger('mtapp.duplicate', [updateContentData, false]);
                        });
                    }
                    // 記事一覧画面で実行された場合
                    else if (mtappVars.screen_id === 'list-entry') {
                        $body.trigger('mtapp.duplicate', [updateContentData, true]);
                    }
                }
            );
        }
    });
}
